import React, { useState, useEffect } from "react";
import { savePayment, getPaymentMethod } from "../../../service/cartService";
import { FromatNumberVIE } from '../../../utils/format';

const PaymentMobile = (props) => {

     const [listPayment, setListPayment] = useState([]);
    
        const showListPayment =()=>{
            try {
                getPaymentMethod().then((response)=>{
                    console.log(response);
                    if(response.status === 200){
                        setListPayment(response.message);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }

    useEffect(() => {
        props.parentCallback(false);
        handlePushPayment('cod');
        showListPayment();
    }, []);
    const [isShowVoucher, setIsShowVoucher] = useState(true);
    const handleVoucher = () => {
        setIsShowVoucher(!isShowVoucher);
    };
    const [pushVoucher, setPushVocher] = useState(false);
    const handleClickPushCode = () => {
        setPushVocher(!pushVoucher);
        setIsShowMore(false)
        setIsShowVisa(false);
        setIsShowTextMomo(false);
        setIsTranfer(false);
    }
    const handleBixu = () => {
        setPushVocher(false);
    }
    const [isShowMore, setIsShowMore] = useState(true);
    const handleClickShowMore = () => {
        setIsShowMore(!isShowMore);
        setPushVocher(false);
    }
    const [isShowVisa, setIsShowVisa] = useState(false);
    const handleShowVisa = () => {
        setIsShowVisa(!isShowVisa);
        setIsShowTextMomo(false);
        setIsTranfer(false);
    }
    const [isShowTextMomo, setIsShowTextMomo] = useState(false);
    const handleShowTextMomo = () => {
        setIsShowTextMomo(!isShowTextMomo);
        setIsShowVisa(false);
        setIsTranfer(false);
    }
    const [isTranfer, setIsTranfer] = useState(false);
    const handleTranfer = () => {
        setIsTranfer(!isTranfer);
        setIsShowVisa(false);
        setIsShowTextMomo(false);
    }
    const handlePushPayment = (code) => {
        props.parentCallback(true);
        try {
            savePayment(code, window.localStorage.getItem('key')).then((response) => {
                console.log(response);
                props.parentCallback(true);
            });
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <>
            <div className="bg-white">
            <div className="pdb-5 pdx-10 mgx-20 pdt-20 text-normal-12-700 d-flex justify-content-between border-b">
                <span className="">THANH TOÁN BẰNG VOUCHER/ BIXU</span>
                <a> <span className="text-normal-13" onClick={() => handleVoucher()}>Khác <i className={isShowVoucher ? ("fa fa-angle-up pdl-5") : ("fa fa-chevron-down pdl-5")}></i></span></a>
            </div>
            {
                isShowVoucher ? (
                    <div className="row mgx-20">
                        <ul className="list-delivery-method pdx-0">
                            <li key="key_1" className="w-100">
                                <div className="row w-100 align-items-center mgx-0">
                                    <div className="col-2 float-left pdx-0">
                                        <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/su_dung_voucher.png" alt="icon"/>
                                    </div>
                                    <div className="col-8 pdx-0">
                                        <span className="text-normal-13">Sử dụng Voucher (Phiếu ưu đãi) <br />
                                            {/* Bạn hiện có 06 Voucher */}
                                        </span>
                                    </div>
                                    <div className="col-2 pdr-5 float-right pdx-0">
                                        <input disabled className="form-check-input" type="radio" name="payment" defaultChecked={pushVoucher ? true : false} onClick={() => handleClickPushCode()} />
                                    </div>
                                </div>
                                {
                                    pushVoucher ? (
                                        <div className="pay-apply-discount">
                                            <div className="apply-discount-text">
                                                <span>ÁP DỤNG MÃ GIẢM GIÁ</span>
                                            </div>
                                            <div className="discount-button">
                                                <input className="discount-input" placeholder="Bạn có 6 voucher sẵn sàng sử dụng" />
                                                <button type="submit" className="btn btn-primary">Chọn mã</button>
                                            </div>
                                        </div>
                                    ) : (null)
                                }


                            </li>
                            <li key="key_2" className="w-100">
                                <div className="row w-100 align-items-center mgx-0">
                                    <div className="col-2 float-left pdx-0">
                                        <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/su_dung_bixu.png" alt="icon"/>
                                    </div>
                                    <div className="col-8 pdx-0">
                                        <div className="col-12 d-flex">
                                            <span className="text-normal-13 line-hei-15">Sử dụng Bixu tích luỹ </span>
                                        </div>
                                        <div className="col-12 d-flex">
                                            <span className="text-normal-13 line-hei-15">Bạn hiện có {window.localStorage.getItem('bixu') !== null ? FromatNumberVIE(+window.localStorage.getItem('bixu')) : 0} Bixu</span>
                                        </div>
                                    </div>
                                    <div className="col-2 pdr-5 float-right pdx-0">
                                        <input disabled className="form-check-input" type="radio" name="payment" onClick={() => handleBixu()} />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                ) : (null)
            }


            <div className="pdb-5 pdx-10 mgx-20 pdt-20 text-normal-12-700 d-flex justify-content-between border-b">
                <span className="">CHỌN HÌNH THỨC THANH TOÁN</span>
                <a><span className="text-normal-13" onClick={() => handleClickShowMore()}>Khác <i className={isShowMore ? ("fa fa-angle-up pdl-5") : ("fa fa-chevron-down pdl-5")}></i></span></a>
            </div>
            {
                isShowMore ? (
                    <div className="row mgx-20">
                        <ul className="list-delivery-method pdx-0">
                            {/* <li key="key_3" className="w-100">
                                <div className="row w-100 align-items-center mgx-0">
                                    <div className="col-2 float-left pdx-0">
                                        <img src="/images/cart/image_650.png" alt="icon"/>
                                    </div>
                                    <div className="col-8 pdx-0">
                                        <div className="col-12 d-flex">
                                            <span className="text-normal-13 line-hei-15">Thanh toán (COD) </span>
                                        </div>
                                        <div className="col-12 d-flex">
                                            <span className="text-normal-13 line-hei-15">Thanh toán khi nhận hàng</span>
                                        </div>
                                    </div>
                                    <div className="col-2 pdr-5 float-right pdx-0">
                                        <input defaultChecked className="form-check-input" type="radio" name="payment" id="COD" onClick={() => handlePushPayment('cod')} />
                                    </div>
                                </div>
                            </li> */}
                            {
                                listPayment.length > 0 ? (
                                    listPayment.map((item, index)=>{
                                        return <li key={"Key_"+index} className="w-100">
                                                <div className="row w-100 align-items-center mgx-0">
                                                    <div className="col-2 float-left pdx-0">
                                                        <img className="icon-payment" src={item.icon} alt={item.name}/>
                                                    </div>
                                                    <div className="col-8 pdx-0">
                                                        <div className="col-12 d-flex">
                                                            <span className="text-normal-13 line-hei-15">{item.name}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-2 pdr-5 float-right pdx-0">
                                                        <input defaultChecked={item._id==='cod'?(true):(null)} className="form-check-input" type="radio" name="payment" id="COD" onClick={() => handlePushPayment(item._id)} />
                                                    </div>
                                                </div>
                                            </li> 
                                    })
                                ):(null)
                            }

                            {/* <li key="key_4" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/image 648.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Thẻ tín dụng/ Thẻ ghi nợ <br />(Visa, Master Card, JCB)</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" defaultChecked={isShowVisa ? true : false} onClick={() => handleShowVisa()} />
                                    </div>
                                </div>
                            </li>
                            <li key="key_5" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/image 643.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Thanh toán ví Momo</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" defaultChecked={isShowTextMomo ? true : false} onClick={() => handleShowTextMomo()} />
                                    </div>
                                </div>
                            </li>
                            <li key="key_6" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/image 647.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Thanh toán ví VNPay</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" />
                                    </div>
                                </div>
                            </li>
                            <li key="key_7" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/image 642.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Thanh toán ví ZaloPay</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" />
                                    </div>
                                </div>
                            </li>
                            <li key="key_8" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/image 644.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Thanh toán ví ShoppePay</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" />
                                    </div>
                                </div>
                            </li>
                            <li key="key_9" className="w-100">
                                <div className="row w-100 align-items-center">
                                    <div className="col-2 text-center">
                                        <img src="/images/cart/430296 1.png" />
                                    </div>
                                    <div className="col-9">
                                        <span className="text-normal-13">Chuyển khoản ngay</span>
                                    </div>
                                    <div className="col-1">
                                        <input disabled className="form-check-input" type="radio" name="payment" />
                                    </div>
                                </div>
                            </li> */}
                        </ul>
                    </div>
                ) : (null)
            }
            </div>
        </>
    )
}

export default PaymentMobile;